import React from 'react';
import './Chapters.scss';

function Chapter9() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        To build tools that can answer those kinds of questions, you need a huge amount of data. Not
        even a hospital has a big enough volume of patients to provide those answers, so you need to
        aggregate data across multiple hospitals.
      </p>
      <p className="chapter__paragraph">
        That’s exactly what Datarwe does in its “Clinical Data Nexus” The Nexus enables researchers,
        clinical product developers, and clinicians in 17 hospitals across Australia to collaborate
        on national and international data sets and gives them a place to test their theories and
        hypotheses using aggregated, anonymized data, collected, for example, from thousands of
        devices, including bedside blood pressure monitors, electrocardiogram (ECG) machines, and
        imaging equipment from hundreds of thousands of treatment and care “episodes.”
      </p>
      <p className="chapter__paragraph">
        Ultimately, Woodyatt believes that Datarwe will enable precision medicine advances that
        benefit everyone. Patients will get more effective treatments, public health systems can
        respond better to crises such as pandemics, and providers will be able to lower costs by
        following the evidence on best practices and achieving huge cost savings.
      </p>
      <p className="chapter__paragraph">
        All of the data Datarwe uses is housed on AWS infrastructure with Intel technologies.
        Woodyatt says the scalability of AWS and the processing power of Intel have been crucial to
        enabling the functionality of the Clinical Data Nexus.
      </p>
      <p className="chapter__paragraph">
        “Our clinicians and researchers are always adding bigger and increasingly diverse
        demographic data sets to the platform,” Woodyatt says. “The power from the Intel side is key
        to handling that data processing.”
      </p>
    </section>
  );
}

export default Chapter9;
